import { createIcon } from "@chakra-ui/react";

export const DrawerIcon = createIcon({
  displayName: "DrawerIcon",
  viewBox: "0 0 24 24",
  defaultProps: {
    boxSize: "24px",
  },
  path: (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
      fill="#181E26"
    />
  ),
});
